import { initializeApp } from "firebase/app"
import { getDatabase } from "firebase/database"

import { env } from "@/env"

const firebaseConfig = env.firebase

const app = initializeApp(firebaseConfig)
export const database = getDatabase(app)
